<!--
 * @Author: houmy
 * @Date: 2023-09-18 21:31:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-27 15:40:06
 * @FilePath: \zx-home\src\views\News.vue
 * @Description: 
 * 
-->

<template>
    <div class="page">
        <Contact></Contact>
        <img class="newsBanner" src="../assets/img/news/banner.png" alt="">
        <div class="newsPageList news home-box">
            <div class="page-title">
                <i></i>
                <span>文章列表</span>
            </div>
            <ul class="newsMain">
                <li class="flex-row" v-for="(item, index) in newsArr" @click="toDetail(item, index)">
                    <img class="newsImg" :src="item.img" />
                    <p class="flex-col">
                        <b>{{ item.title }}</b>
                        <span>{{ item.info }}</span>
                        <label>{{ item.time }}
                            <img src="@/assets/img/rightBlueBg.png" />
                        </label>
                    </p>
                </li>

            </ul>
        </div>





    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
export default {
    components: {
        Contact
    },
    data() {
        return {
            media: {
                img1: require('../assets/img/news/pic1.png'),
                img2: require('../assets/img/news/pic2.png'),
                img2_2: require('../assets/img/news/pic2-2.png'),
                img2_3: require('../assets/img/news/pic2-3.jpg'),
                img3: require('../assets/img/news/pic3.png'),
                img4: require('../assets/img/news/pic4.png'),
                video1: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/demo3.mp4',
                video2: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/video2.mp4',
                video3: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/video3.mp4',
                video4: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/video4.mp4',
                // video3: require('../assets/img/news/video3.m4v'),
            },
            newsArr: []
        };
    },
    mounted() {
        this.$nextTick(() => {
                window.scrollTo(0, 0)
            })
        this.newsArr = [{
            title: '六力智造 | SAD200自动驾驶作业系统',
            info: '六力智行基于8年行业积累，整合车规技术，研发打造了SAD200自动驾驶作业系统，基于北斗，源于智能，更懂用户！SAD200自动驾驶作业系统，将自动驾驶与作业控制融合，不仅仅是简单和智能，更能创造价值，值得拥有！',
            img: require('../assets/img/news/pic1.png'),
            time: '2023-07-13 10:24',
            content: `<p>六力智行基于8年行业积累，整合车规技术，研发打造了SAD200自动驾驶作业系统，基于北斗，源于智能，更懂用户！SAD200自动驾驶作业系统，将自动驾驶与作业控制融合，不仅仅是简单和智能，更能创造价值，值得拥有！</p>
                <img src="${this.media.img1}" alt=""/>
                <p>【一键掉头】：地头一键掉头，自动转弯控制、作业装置控制、作业速度控制，轻松适应各种工况，可以升级自动掉头。 </p>
                <p>【高品质】：车规级高性能处理器和品质要求， 更快更强更安全!工况适应性强：车身姿态测量和地形补偿，适应多种工况。 </p>
                <p>【使用简单】：无接触式转角测量，简单可靠，无需标定；自动匹配历史作业轨迹，简单高效。 </p>
                <p>【信号稳定】：多种差分信号方式，三网合一，信号更稳定；支持无线电台通信。 </p>
                <p>【更省人工】：每台车节省1-2人，快速回本并创造价值。 </p>
                <p>【智能与安全】：地头自动报警，更安全，可升级环境感知与安全避障设备。SAD200自动驾驶作业系统田间插秧作业视频：</p>
                <video src="${this.media.video1}" controls></video>
                `
        }, {
            title: '六力快讯 | 热烈庆祝六力智行成立一周年!',
            info: '周年庆典2022.7.7—2023.7.7，有幸与党同月生日，时光荏苒，转眼一周年，这一年是拾回初心的一年，是生根发芽的一年，是厚积薄发的一年，从蹒跚学步到逐步壮大，感谢大家的努力，一路同行，我们会越来越好！',
            img: require('../assets/img/news/pic2.png'),
            time: '2023-07-12 16:41',
            content: `<p>周年庆典2022.7.7—2023.7.7，有幸与党同月生日，时光荏苒，转眼一周年，这一年是拾回初心的一年，是生根发芽的一年，是厚积薄发的一年，从蹒跚学步到逐步壮大，感谢大家的努力，一路同行，我们会越来越好！</p>
                <img src="${this.media.img2}" alt=""/>
                <p>2023年7月7日是公司成立一周年的日子，是所有六力人的盛大节日。公司在这天特举行一周年庆典活动，盛邀大家携同家属一同出席。活动议程： 17:30-18:00 嘉宾签到；18:00-18:05 主持人开场辞；18:10-18:15 签约仪式；18:20-18:45 领导致辞18:45-18:50 集体合影留念；18:50 晚宴开始烤全羊、烧鹅、毛血旺、牛蛙、白酒红酒、冰可乐......丰富的菜品应有尽有。桌上有肉，杯中有酒。烟火起、照人间、喜悦无边，举杯敬此年。年年有风，风吹年年。我们年复一年、年赴一年、年富一年。</p>
                <img src="${this.media.img2_2}" alt=""/>
               
                <p>进总感谢大家的到来，感谢大家对六力智行一路以来的支持与陪伴，有大家付出与信任才会有六力智行的现在。进总随后从公司发展历程，目前公司形态以及未来规划三方面展开报告：从去年7月刚成立的小团队逐渐壮大到大大小小的部门，总人数发展到32人且研发人员占比超过84%。目前，我们的产品矩阵逐渐成熟，部分产品已经具备量产条件和出口条件。在未来的岁月里，我们将会从此刻出发，依托软硬件平台化设计、系统整体集成、核心算法、场景定制开发构建属于我们六力智行的智能作业生态体系。</p>
                    <p>热烈庆祝广东六力智行科技有限公司与广州市汇奥机电有限公司就智能农机、无人驾驶作业和智慧农场等领域开展合作。双方本着互惠互利、健康发展、高效优质的合作精神，结成深度的战略合作伙伴关系！ </p>
                <img src="${this.media.img2_3}" alt=""/>
               
                <p>感谢所有同仁的选择，相信自己的选择，一起来创造波澜壮阔的明天！</p>
                <p>感谢所有家人的支持和贡献，共同撑起大家和小家，心手相连！</p>
                <p>感谢合作伙伴的帮助，我们快速成长，积极反哺，携手共进！</p>
                <p>感谢投资人的信任，投资六力，做有价值、创造价值的事业！</p>
               
                <video src="${this.media.video2}" controls></video>
                `
        }, {
            title: '六力快讯丨韦总&《车后快豹》采访',
            info: '6月30号下午，广东六力智行科技有限公司感知产品总监韦建全参加广州2023年商用车主题沙龙。智感万物，看见未来 “2023车载摄像头市场变革与扩张”主题沙龙企业如何利用好庞大的汽车领域应用需求，参与到新型技术的市场应用？智能驾驶与车联网深入耦合，要求车载摄像头质、量齐升~不仅要看得清，更要看得好！我们一同感受现场报道~',
            img: require('../assets/img/news/pic3.png'),
            time: '2023-07-12 15:00',
            content: `
            <p>6月30号下午，广东六力智行科技有限公司感知产品总监韦建全参加广州2023年商用车主题沙龙。</p>
                <p>智感万物，看见未来 “2023车载摄像头市场变革与扩张”主题沙龙</p>
                    <p>企业如何利用好庞大的汽车领域应用需求，参与到新型技术的市场应用？</p>
                        <p>智能驾驶与车联网深入耦合，要求车载摄像头质、量齐升~不仅要看得清，更要看得好！</p>
                            <p>我们一同感受现场报道~</p>
                            <video src="${this.media.video3}" controls></video>
            `
        },
        {
            title: '六力智造丨SAD300自动驾驶收获作业系统',
            info: '农业机械化程度的不断提升大大提高了我国农业生产力，但传统机械依然存在高度依赖人工、劳动强度大、操控技能要求高、作业质量难保证、夜间作业问题多等难题。',
            img: require('../assets/img/news/pic4-0.jpg'),
            time: '2023-11-15 14:47',
            content: `
                <p>农业机械化程度的不断提升大大提高了我国农业生产力，但传统机械依然存在高度依赖人工、劳动强度大、操控技能要求高、作业质量难保证、夜间作业问题多等难题。</p>
                <p>为使农户获得更加智能、轻松、高效的作业体验，实现降本增收的目标，六力智行潜心研究，精进农机导航自动驾驶解决方案，深耕农机农艺融合，让农事作业更智能、简单、省人，创造看得见、抓得住的价值。</p>
                <img src="${this.media.img4}" alt=""/>
                <p>着眼于广大农户每年作业季时间紧、任务重，耕种管收全流程均需要更高效作业的需求，六力智行SAD300自动驾驶收获作业系统真正实现了：解放双手，操作简单，易学易用；信号稳定，直线度、交接行精准，为万千用户带来省时省力，降本增收的作业体验。</p>
                <p>方案优势：</p>
                <p>【信号稳定】：三网通信，手动或自动选择最优网络，最大化保障信号畅通。</p>
                <p>【智能规划】：全局路径覆盖，最优化掉头路径，拟人化作业。</p>
                <p>【自动卸粮】：自动卸粮控制，自动选择卸粮时机和最优化卸粮局部路径设计。</p>
                <p>【智能作业】：轨迹跟踪精度高，作业行重叠少，提高作业效率。</p>
                <p>【使用简单】：人机结合，一键手/自动切换，兼顾人的灵活与自动驾驶作业的科技价值创造。</p>
                <p>SAD300自动驾驶收获作业系统田间收割作业：</p>
                <video src="${this.media.video4}" controls></video>
            `
        }
    ]
    },
    methods: {
        // 跳转详情
        toDetail(item, index) {
            localStorage.setItem('newsList', JSON.stringify(this.newsArr))
            localStorage.setItem('newsDetail', JSON.stringify(item))
            this.$router.push({
                path: '/newsDetail',
                query: {
                    index: index,
                    lastTitle: this.newsArr[index - 1] ? this.newsArr[index - 1].title : '',
                    nextTitle: this.newsArr[index + 1] ? this.newsArr[index + 1].title : '',
                }
            })
        }

    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/News.vue